export const ASO = [
  { value: 'Admissional' },
  { value: 'Periódico' },
  { value: 'Mudança de Riscos' },
  { value: 'Retorno ao Trabalho' },
  { value: 'Monitoramento' },
  { value: 'Demissional' }
];
